import { Box, Stack } from '@ff-it/ui';
import { useFieldValue } from 'hooks';
import { ReactElement } from 'react';

import { EditBandSet, ViewBandSet } from './BandSet';
import { RadioTimeBands } from '../types';
import { BoolIcon } from 'components/Icon';
import { BandDayTypeSplitToggle } from '../common/BandDayTypeSplitToggle';

export function ViewBandsHeader({ bands: { day_type_split: split } }: { bands: RadioTimeBands }): ReactElement {
  return (
    <Stack direction="horizontal">
      Time bands
      <Box display="flex" alignItems="center" ml="auto">
        <BoolIcon>{split}</BoolIcon>
        <Box as="label" mb="0" ml="2" htmlFor="split-toggle" fontWeight="regular" fontSize="sm">
          Weekday / weekend split
        </Box>
      </Box>
    </Stack>
  );
}

export function ViewBands({ bands }: { bands: RadioTimeBands }): ReactElement {
  return (
    <Box>
      <Stack direction="horizontal">
        {bands.day_type_split ? (
          <>
            <ViewBandSet dayType="WD" bands={bands.WD} />
            <ViewBandSet dayType="WE" bands={bands.WE} />
          </>
        ) : (
          <Box width="1/2">
            <ViewBandSet dayType="ALL" bands={bands.ALL} />
          </Box>
        )}
      </Stack>
    </Box>
  );
}

const initialBandValue = {
  start_hour: null,
  end_hour: null,
  __NEW__: Date.now(),
};

export function EditBandsHeader(): ReactElement {
  const split = useFieldValue<boolean>('bands.day_type_split', { allowNull: false });
  return (
    <Stack direction="horizontal">
      Time bands
      <BandDayTypeSplitToggle ml="auto" initialBandValue={initialBandValue} split={split} />
    </Stack>
  );
}

export function EditBands(): ReactElement {
  const split = useFieldValue<boolean>('bands.day_type_split', { allowNull: false });

  return (
    <Box>
      <Stack direction="horizontal">
        {split ? (
          <>
            <EditBandSet dayType="WD" />
            <EditBandSet dayType="WE" />
          </>
        ) : (
          <Box width="1/2">
            <EditBandSet dayType="ALL" />
          </Box>
        )}
      </Stack>
    </Box>
  );
}
